import React, { PureComponent } from 'react';
import {PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend} from 'recharts';
import PropTypes from "prop-types";

const COLORS = ['#82ca9d', '#8884d8', '#FFBB28', '#FF8042'];
const RADIAN = Math.PI / 180; 

class SimplePieChart extends PureComponent {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape({
            Nombre: PropTypes.string,
            Valor: PropTypes.number,
        })).isRequired,
    }


  renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, entry }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x  = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy  + radius * Math.sin(-midAngle * RADIAN);
  
   return (
     <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} 	dominantBaseline="central">
       {`${(percent * 100).toFixed(0)}%`}
     </text>
   );
  }

	render () {
  	return (
      <ResponsiveContainer height={300} width='100%'>
        <PieChart onMouseEnter={this.onPieEnter}>

          <Pie
            data={this.props.data}
            cx='50%' 
            cy={150}
            // labelLine={false}
            label={this.renderCustomizedLabel}
            outerRadius={100}
            fill="#8884d8"
            dataKey="Valor"
          >
            {
                this.props.data.map((entry, index) => <Cell key={entry} value ={entry.name} fill={COLORS[index % COLORS.length]} />)
            }
            <Legend />
              <Tooltip />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default SimplePieChart;
